import { render } from "./addMeal.vue?vue&type=template&id=239533b1&scoped=true"
import script from "./addMeal.vue?vue&type=script&lang=js"
export * from "./addMeal.vue?vue&type=script&lang=js"

import "./addMeal.vue?vue&type=style&index=0&id=239533b1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-239533b1"]])

export default __exports__